import {useSelector} from 'react-redux';

export default function useCollaborator() {
  return useSelector((state: any) => state.authentication.user);
}
